import { submittable } from './status';

const optionalSubmittable = ({ content }, state = {}, feedback = {}) => {
  let result = submittable(content, state, feedback);

  if (content.optional) {
    if (!state.submitted) {
      result.submittable = 1;
    } else {
      delete result.submittable;
    }
  }

  return result;
};

export { optionalSubmittable };
